/* app/js/src/components/broadcast/switcher-item/switch-item-block-manager/switch-item-block-manager.component.scss */
.switch-item-block-manager {
  border-radius: 0px 0px 10px 10px;
  border-style: solid;
  border-color: #000000;
  border-width: 1px;
  display: flex;
  flex-direction: column;
  gap: 0px;
  align-items: flex-start;
  justify-content: flex-start;
  flex-shrink: 0;
  position: relative;
  height: 100vh;
  width: 100vw;
  font-family: "OpenSans-Regular", sans-serif;
  background-color: #ffffff;
  -webkit-user-select: none;
  user-select: none;
}
.table-header-bar {
  padding: 0px 10px 0px 10px;
  display: flex;
  flex-direction: row;
  gap: 0px;
  align-items: center;
  justify-content: flex-start;
  align-self: stretch;
  flex-shrink: 0;
  height: 21px;
  position: relative;
  z-index: 10;
}
.table-header-bar.is-stack {
  background: #55928e;
}
.table-header-bar.is-block {
  background: #cf5c81;
}
.header-left {
  padding: 0px 5px 0px 5px;
  display: flex;
  flex-direction: row;
  gap: 0px;
  align-items: center;
  justify-content: flex-start;
  align-self: stretch;
  flex: 1;
  position: relative;
}
.header-left .stack-name {
  color: var(--dark-text-clean-white, #ffffff);
  text-align: left;
  font-family: "OpenSans-Regular", sans-serif;
  font-size: 12px;
  line-height: 18px;
  font-weight: 400;
  position: relative;
  flex: 1;
}
.header-right {
  padding: 0px 24px 0px 24px;
  display: flex;
  flex-direction: row;
  gap: 0px;
  align-items: center;
  justify-content: flex-end;
  align-self: stretch;
  flex-shrink: 0;
  width: 100px;
  position: relative;
}
.header-right .total-duration {
  color: var(--dark-text-clean-white, #ffffff);
  text-align: right;
  font-family: "OpenSans-Regular", sans-serif;
  font-size: 12px;
  line-height: 18px;
  font-weight: 400;
  position: relative;
  flex: 1;
}
.table-content-wrapper {
  display: flex;
  flex-direction: row;
  gap: 10px;
  justify-content: space-between;
  width: 100%;
  flex: 1;
  min-width: 0;
  min-height: 0;
  overflow: hidden;
}
.table-container {
  background: #ffffff;
  padding: 0px 0px 0px 8px;
  display: flex;
  flex-direction: row;
  gap: 0px;
  align-items: flex-start;
  justify-content: flex-start;
  align-self: stretch;
  flex-shrink: 1;
  position: relative;
  flex: 0 0 70%;
  min-width: 0;
  min-height: 0;
  overflow-y: auto;
  overflow-x: hidden;
}
.playlist-table {
  width: 100%;
  min-width: 0;
  border-collapse: collapse;
  table-layout: fixed;
}
col.col-drag {
  width: 31px;
}
col.col-play-time {
  width: 120px;
}
col.col-duration {
  width: 90px;
}
col.col-played {
  width: 80px;
}
col.col-mute {
  width: 170px;
}
col.col-hide {
  width: 140px;
}
.playlist-table.is-stack col.col-name {
  width: auto;
}
.playlist-table.is-block col.col-name {
  width: auto;
}
.playlist-table thead th {
  background: var(--light-text-primary, linear-gradient(to left, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(to left, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(to left, rgba(0, 0, 0, 0.85), rgba(0, 0, 0, 0.85)));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-align: left;
  font-family: "OpenSans-Bold", sans-serif;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  padding: 0 5px;
  height: 22px;
  vertical-align: middle;
}
.playlist-table tbody tr {
  height: 22px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}
.playlist-table tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.05);
}
.playlist-table tbody tr.current-row {
  background: var(--success-main, #00ca69) !important;
}
.playlist-table tbody tr.selected-row {
  background: #ebf0f4 !important;
}
.playlist-table tbody tr.dragging {
  opacity: 0.5;
  background-color: rgba(0, 0, 0, 0.1);
  cursor: grabbing;
}
.playlist-table tbody td {
  background: var(--light-text-primary, linear-gradient(to left, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(to left, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(to left, rgba(0, 0, 0, 0.85), rgba(0, 0, 0, 0.85)));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  text-align: left;
  font-family: "OpenSans-Regular", sans-serif;
  font-size: 12px;
  line-height: 18px;
  font-weight: 400;
  padding: 0 5px;
  vertical-align: middle;
  overflow: hidden;
}
.playlist-table tbody tr.current-row td {
  background: var(--light-text-primary, linear-gradient(to left, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(to left, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(to left, rgba(0, 0, 0, 0.85), rgba(0, 0, 0, 0.85)));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 11.2220001221px;
  line-height: 16.83px;
}
.playlist-table tbody tr.selected-row td {
  background: var(--light-text-primary, linear-gradient(to left, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(to left, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(to left, rgba(0, 0, 0, 0.85), rgba(0, 0, 0, 0.85)));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.playlist-table tbody tr.current-row td.name-column,
.playlist-table tbody tr.selected-row td.name-column {
  background: none !important;
  background-clip: border-box !important;
  -webkit-background-clip: border-box !important;
  -webkit-text-fill-color: rgba(0, 0, 0, 0.85) !important;
}
.playlist-table tbody tr.current-row td.mute-audio-column,
.playlist-table tbody tr.current-row td.hide-logo-column,
.playlist-table tbody tr.selected-row td.mute-audio-column,
.playlist-table tbody tr.selected-row td.hide-logo-column {
  background: none !important;
  background-clip: border-box !important;
  -webkit-background-clip: border-box !important;
  -webkit-text-fill-color: initial !important;
}
.drag-handle {
  width: 31px;
  text-align: center;
  padding: 0 5px;
}
.name-column {
  overflow: hidden;
  max-width: 0;
  background: none !important;
  background-clip: border-box !important;
  -webkit-background-clip: border-box !important;
  -webkit-text-fill-color: rgba(0, 0, 0, 0.85) !important;
  color: rgba(0, 0, 0, 0.85);
}
.name-column__text {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  width: 100%;
}
.play-time-column {
  width: 120px;
}
.duration-column {
  width: 90px;
}
.played-column {
  width: 80px;
}
th.mute-audio-column,
th.hide-logo-column {
  background: none !important;
  background-clip: border-box !important;
  -webkit-background-clip: border-box !important;
  -webkit-text-fill-color: initial !important;
  text-align: center;
  padding: 0 4px;
  overflow: hidden;
}
td.mute-audio-column,
td.hide-logo-column {
  background: none !important;
  background-clip: border-box !important;
  -webkit-background-clip: border-box !important;
  -webkit-text-fill-color: initial !important;
  text-align: center;
  padding: 0;
  overflow: visible;
}
.checkbox-column-header {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  max-width: 100%;
  line-height: 1;
  vertical-align: middle;
}
.checkbox-column-header input[type=checkbox] {
  flex: 0 0 16px;
  width: 16px;
  height: 16px;
  margin: 0;
  cursor: pointer;
  accent-color: #55928e;
}
.checkbox-column-header__label {
  font-family: "OpenSans-Bold", sans-serif;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  line-height: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  background: var(--light-text-primary, linear-gradient(to left, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(to left, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), linear-gradient(to left, rgba(0, 0, 0, 0.85), rgba(0, 0, 0, 0.85)));
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
.checkbox-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 22px;
}
.checkbox-cell input[type=checkbox] {
  width: 16px;
  height: 16px;
  margin: 0;
  cursor: pointer;
  accent-color: #55928e;
}
.drag-icon {
  color: rgba(0, 0, 0, 0.2);
  font-size: 12px;
  cursor: grab;
  -webkit-user-select: none;
  user-select: none;
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.2s ease;
}
.drag-icon:hover {
  color: rgba(0, 0, 0, 0.4);
}
.drag-icon--disabled {
  opacity: 0.35;
  cursor: not-allowed;
}
.playlist-table tbody tr.stack-editing-disabled {
  cursor: default;
}
.playlist-table tbody tr.current-row .drag-icon,
.playlist-table tbody tr.selected-row .drag-icon {
  color: rgba(0, 0, 0, 0.2);
}
.playlist-table tbody tr.dragging .drag-icon {
  color: rgba(0, 0, 0, 0.6);
  cursor: grabbing;
}
.duration-column {
  color: var(--scheduler-text, #000000);
  text-align: left;
  font-family: "OpenSans-Regular", sans-serif;
  font-size: 11px;
  font-weight: 400;
  background: none;
  -webkit-text-fill-color: initial;
}
@media (max-width: 768px) {
  .playlist-table thead th,
  .playlist-table tbody td {
    padding: 0 3px;
    font-size: 10px;
  }
  .play-time-column {
    width: 100px;
  }
  .duration-column {
    width: 80px;
  }
  .played-column {
    width: 70px;
  }
  .mute-audio-column {
    width: 120px;
  }
  .hide-logo-column {
    width: 110px;
  }
}
@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
.action-bar {
  background: var(--light-other-bg-02, rgba(35, 47, 58, 0.05));
  border-style: solid;
  border-color: var(--light-other-outline-border, rgba(0, 0, 0, 0.14));
  border-width: 1px 0px 0px 0px;
  padding: 0px 24px 0px 24px;
  display: flex;
  flex-direction: row;
  gap: 0px;
  align-items: center;
  justify-content: space-between;
  align-self: stretch;
  flex-shrink: 0;
  height: 40px;
  position: relative;
  z-index: 10;
  box-sizing: border-box;
}
.action-bar__mode-buttons {
  display: flex;
  flex-direction: row;
  gap: 0px;
  align-items: center;
  justify-content: flex-start;
  flex: 1;
  position: relative;
}
.action-bar__mode-btn {
  -webkit-user-select: none;
  user-select: none;
  border-style: solid;
  border-color: var(--light-other-divider, rgba(0, 0, 0, 0.1));
  border-width: 0px 1px 0px 1px;
  background: transparent;
  display: flex;
  flex-direction: row;
  gap: 0px;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  flex-shrink: 0;
  width: 100px;
  height: 100%;
  position: relative;
  cursor: pointer;
  transition: background-color 0.2s ease;
  font-family: "OpenSans-SemiBold", sans-serif;
  font-size: 12px;
  line-height: 18px;
  font-weight: 600;
  text-transform: uppercase;
  color: var(--light-text-secondary, rgba(0, 0, 0, 0.54));
  cursor: pointer;
  outline: none;
  padding: 0;
  margin: 0;
}
.action-bar__mode-btn:hover,
.action-bar__mode-btn:active,
.action-bar__mode-btn.active {
  color: #000;
}
.action-bar__mode-btn--program {
  border-width: 0px 1px 0px 0px;
}
.action-bar__toggle-section {
  display: flex;
  flex-direction: row;
  gap: 0px;
  align-items: center;
  justify-content: flex-end;
  flex-shrink: 0;
  position: relative;
  padding: 0px 10px 0px 10px;
}
.thumbnail-container {
  flex-shrink: 0;
  flex: 0 0 29%;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 5.625%;
  padding-right: 50px;
  height: 50vh;
  overflow: hidden;
}
.thumbnail-container div {
  width: 100%;
  height: 100%;
  background-size: contain;
  background-repeat: no-repeat;
}
.playlist-table tbody tr.drop-indicator {
  background-color: rgba(122, 125, 123, 0.2) !important;
  border: 2px dashed #dee6e2;
  position: relative;
  transition: all 0.2s ease;
  transform: scale(1.02);
}
.playlist-table tbody tr.drop-indicator::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 2px;
  background-color: #dee6e2;
  z-index: 1;
  animation: dropIndicatorPulse 1s ease-in-out infinite;
}
.playlist-table tbody tr.drop-indicator::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 2px;
  background-color: #dee6e2;
  z-index: 1;
  animation: dropIndicatorPulse 1s ease-in-out infinite;
}
.playlist-table tbody tr:not(.drop-indicator) {
  background-color: transparent;
  border: none !important;
  transform: scale(1) !important;
}
.playlist-table tbody tr:not(.drop-indicator)::before,
.playlist-table tbody tr:not(.drop-indicator)::after {
  display: none !important;
}
@keyframes dropIndicatorPulse {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
}
.grayed-out {
  pointer-events: none;
  opacity: 0.5;
}
.playlist-table tbody tr.group-header-row {
  height: 30px;
  cursor: default;
  background: rgba(0, 0, 0, 0.04) !important;
  border-left: 6px solid var(--group-color, transparent);
  border-top: 3px solid var(--group-color, transparent);
}
.playlist-table tbody tr.group-header-row:hover {
  background: rgba(0, 0, 0, 0.07) !important;
}
.playlist-table tbody tr.group-header-row td.group-header-cell {
  padding: 0 8px;
  background: none !important;
  background-clip: border-box !important;
  -webkit-background-clip: border-box !important;
  -webkit-text-fill-color: initial !important;
  overflow: visible;
  vertical-align: middle;
}
.group-header-cell__inner {
  display: flex;
  align-items: center;
  gap: 8px;
  width: 100%;
  height: 30px;
}
.group-color-dot {
  display: inline-block;
  width: 14px;
  height: 14px;
  border-radius: 50%;
  flex-shrink: 0;
  cursor: pointer;
  border: 1px solid rgba(0, 0, 0, 0.15);
  transition: transform 0.15s ease;
}
.group-color-dot:hover {
  transform: scale(1.25);
}
.group-label-input {
  flex: 1;
  height: 22px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 3px;
  background: white;
  -webkit-user-select: text;
  user-select: text;
  font-family: "OpenSans-Bold", sans-serif;
  font-size: 11px;
  font-weight: 700;
  color: rgba(0, 0, 0, 0.8);
  outline: none;
  padding: 0 6px;
  min-width: 0;
  cursor: text;
}
.group-label-input:focus {
  border-color: var(--group-color, #55928e);
  box-shadow: 0 0 0 2px rgba(85, 146, 142, 0.15);
}
.group-label-input::placeholder {
  color: rgba(0, 0, 0, 0.35);
  font-weight: 400;
  font-style: italic;
}
.group-remove-btn {
  flex-shrink: 0;
  background: transparent;
  border: none;
  cursor: pointer;
  color: rgba(0, 0, 0, 0.35);
  font-size: 12px;
  padding: 2px 4px;
  line-height: 1;
  border-radius: 2px;
  transition: color 0.15s ease, background 0.15s ease;
}
.group-remove-btn:hover {
  color: #d95f6a;
  background: rgba(217, 95, 106, 0.08);
}
.playlist-table tbody tr.in-group {
  border-left: 6px solid var(--group-color, transparent);
}
.playlist-table tbody tr.in-group td.drag-handle {
  padding-left: 1px;
}
.playlist-table tbody tr.group-end-separator {
  height: 4px;
  cursor: default;
  pointer-events: none;
}
.playlist-table tbody tr.group-end-separator td.group-end-separator-cell {
  padding: 0;
  height: 4px;
  background: var(--group-color, transparent) !important;
  background-clip: border-box !important;
  -webkit-background-clip: border-box !important;
  -webkit-text-fill-color: initial !important;
}
.playlist-table tbody tr.group-header-row,
.playlist-table tbody tr.group-end-separator {
  cursor: default;
  -webkit-user-select: none;
  user-select: none;
}
.group-context-menu__separator {
  height: 1px;
  background: rgba(0, 0, 0, 0.1);
  margin: 3px 0;
}
.group-context-menu__item--muted {
  color: rgba(0, 0, 0, 0.5);
}
.group-context-menu {
  position: fixed;
  background: white;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 2000;
  min-width: 160px;
  padding: 4px 0;
}
.group-context-menu__item {
  padding: 8px 12px;
  cursor: pointer;
  font-family: "OpenSans-Regular", sans-serif;
  font-size: 12px;
  color: #333;
}
.group-context-menu__item:hover {
  background-color: rgba(0, 0, 0, 0.08);
}
.group-context-menu__item--danger {
  color: #d95f6a;
}
.group-context-menu__item--danger:hover {
  background-color: rgba(217, 95, 106, 0.08);
}
/*# sourceMappingURL=switch-item-block-manager.component.css.map */
